// extracted by mini-css-extract-plugin
export default {"content":"DBSecretDialog_content__k5guL","labelContainer":"DBSecretDialog_labelContainer__4k380","hostLabel":"DBSecretDialog_hostLabel__xirEA"};